// extracted by mini-css-extract-plugin
export default {"cont":"Usage_cont__huyie","details":"Usage_details__7FoIj"};